import { Component } from '@angular/core';

@Component({
    selector: 'app-well',
    templateUrl: './well.component.html',
    styleUrl: './well.component.css',
})
export class WellComponent {}
